export default "__VITE_ASSET__Seddl_pi__"